import EventBase from './EventBase'
import EventID from './EventID'

/**
 *  403  -  显示心情
 */

export default class EventMoodShow extends EventBase {
  /**
   * 显示心情构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '', '0', '0', '1', '0', '', '0']
  }

  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 图片相对路径
   */
  get PicPath() {
    return this.Parameter?.[1] || ''
  }
  set PicPath(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * X坐标
   */
  get X() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 出现方式(0:直接出现 1:淡入 2:跳跃)
   */
  get ShowMode() {
    return parseInt(this.Parameter?.[4] ?? '')
  }
  set ShowMode(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * 时间
   */
  get Time() {
    return parseInt(this.Parameter?.[5] ?? '')
  }
  set Time(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }
  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[6] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }

  /// <summary>
  /// 是否素材来源自云网盘
  /// 2是（云网盘公有区资源）
  /// </summary>
  get IsPublicwebdisk() {
    return this.Parameter?.[7] === '2'
  }
  set IsPublicwebdisk(value) {
    this.Parameter && (this.Parameter[7] = value ? '2' : '1')
  }
  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.MoodShow

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
